module.exports = __webpack_public_path__ + "8fb707cb4722e7f57d2dbe78be22f453.png"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/icons/favicon-48.png
 ** module id = 611
 ** module chunks = 0
 **/